import { XUIPanel } from '@xero/xui/react/panel';
import { FC } from 'react';
import './WizardPanel.css';

export interface IWizardPanelProps {
    heading: string;
    content: string;
    svg: JSX.Element;
    actions: React.ReactNode;
}

const WizardPanel: FC<IWizardPanelProps> = (props) => (
    <XUIPanel className='wizard-panel'>
        {<div className='xui-u-flex xui-u-flex-justify-center wizard-panel--svg'>{props.svg}</div>}
        <div className='xui-text-align-center'>
            <div className='xui-padding-top xui-heading-xlarge xui-text-align-center'>{props.heading}</div>
            <div className='xui-padding-small wizard-panel--content'>{props.content}</div>
        </div>
        <div className='xui-margin-top'>{props.actions}</div>
    </XUIPanel>
);

export default WizardPanel;
